import { captureTermsError } from 'src/service/utils/sentry/validation'
import { JoinTerms, JoinTermsDetail, TermsResponse } from "src/types/type"

export const convertTermsData = (termsData: TermsResponse): JoinTerms[] => {
  captureTermsError(termsData)

  const termsResponseKeys = ['SKTTerms', 'KTTerms', 'LGUPTerms'] as const
  const copy = JSON.parse(JSON.stringify(termsData)) as TermsResponse

  for (const [key, value] of Object.entries(copy)) {
    if (termsResponseKeys.includes(key as keyof TermsResponse)) {
      value.Terms = value.Terms.map((terms: JoinTermsDetail, index: number) => ({
        ...terms,
        Required: terms.Required ?? 0,
        Order: parseInt(value.TermsOrder.charAt(index)),
      } as JoinTermsDetail))
      .filter((terms: JoinTermsDetail) => Boolean(terms.Title?.trim()))
    }
  }
  return [
    copy.SKTTerms,
    copy.KTTerms,
    copy.LGUPTerms
  ]
}
